import {ClientUserState} from '../../../shared/scripts/ClientUserState.ts'
import {ReferralTypeEnum} from '../../../../shared/entity_datas/EntityDatas.ts'
import {UIUtilsEjsVariables} from '../../../shared/scripts/UIUtilsEjsVariables.ts'
import {UIUrlParameterNames} from '../../../shared/scripts/ui_html/UIUrlController.ts'
import {UIAjaxWrapper} from '../network/UIAjaxWrapper.ts'
import {UIAPIEndpoints} from '../network/UIAPIEndpoints.ts'
import {type AjaxDataTypes} from '../../../../shared/AjaxDataTypes.ts'
import {type BigId, type DiscordSnowflake} from '@colonist/types'
import {CustomLinkUtils} from '../ui_utils/CustomLinkUtils.ts'

export class ReferralProgramUtils {
    static async getReferralLinkForSharing(): Promise<string> {
        await ClientUserState.requireUser()

        const userId = ClientUserState.userState?.id
        if(userId == undefined) throw new Error('Cannot get referral link without a userId')

        const isMobile = UIUtilsEjsVariables.isUserOnMobile
        const referralType = isMobile ? ReferralTypeEnum.MobileShareReferralProgramStore : ReferralTypeEnum.WebShareReferralProgramStore
        const linkText = `${window.location.origin}#${UIUrlParameterNames.ReferralInvitation}=${userId ?? ''}-${referralType}`
        return linkText
    }

    static async setUserReferrer(discordReferrerId: DiscordSnowflake | undefined, userReferrerId: BigId | undefined, referralTypeId: ReferralTypeEnum) {
        const dataToSend = {referredByDiscordUserId: discordReferrerId, referredByUserId: userReferrerId, referralTypeId: referralTypeId} as unknown as AjaxDataTypes.ReferrerData
        await UIAjaxWrapper.postRequestWhenReady(UIAPIEndpoints.apiSetUserReferrer(), undefined, dataToSend)
    }

    static async processReferralInvitation(parameter: string) {
        await ClientUserState.requireUser()

        const user = ClientUserState.userState
        if(!user) return

        const {referrer, referralType} = CustomLinkUtils.extractReferrerFromShareLink(parameter)

        await ReferralProgramUtils.setUserReferrer(undefined, referrer, referralType)
    }
}
